<tt-field-group v-bind="{ labelId, describedbyId, errorText, hintText, label, required }" :asFieldset="true" class="tt-c-range-field">
  <div class="tt-c-range-field__bar-wrap">
    <div class="tt-c-range-field__bar-outer">
      <div v-for="valueDef in valueDefinitions" class="tt-c-range-field__item">
        <input v-model="value" class="tt-c-range-field__input" type="radio" :id="'tt-range-input-' + valueDef.id" :name="groupName" :aria-describedby="describedbyIdValue" :value="valueDef.id">
        <label class="tt-c-range-field__item-label" :for="'tt-range-input-' + valueDef.id"><span class="tt-u-clip-hide">{{ valueDef.label }}</span></label>
      </div>
    </div>
    <div class="tt-c-range-field__bar"></div>
    <div class="tt-c-range-field__option-labels">
      <span v-for="valueLabelText in textLabels" class="tt-c-range-field__text" aria-hidden="true">{{ valueLabelText }}</span>
    </div>
  </div>
</tt-field-group>
